<script>
import { VSelect } from 'vuetify/lib'
export default {
  name: 'AgrialSelect',
  extends: VSelect,
  props: {
    outlined: {
      type: Boolean,
      default: true
    },
    solo: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
fieldset {
  background-color: white;
}

.v-menu__content--fixed {
    position: fixed;
    margin-top: 60px;
}
</style>
